<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:140px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
						<col style="width:160px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Invoice No</th>
							<td>
								<input type="text" v-model.trim="invoice.invoice_dn" class="tbl_int ssm2_int" readonly disabled />
								S/O No :
								<SoSelect
									v-model.trim="invoice.so_dn"
									:initialStatusCode="initialStatusCode"
									:initialFromDaysAgo="initialFromDaysAgo"
									ph="Enter SO No or Scan Barcode"
									:disabled="mode == 'detail'"
									@set-invoice="setInvoiceFromList"
									@search="search()"
								/>
								<a v-if="invoice.so_dn" href="javascript:;" style="padding-left:10px;" @click="openSO()">Open Sales Order</a>
								<span v-if="invoice.status_code == 'VI'"
									>&nbsp;&nbsp;<font color="red"><b>Void Invoice</b></font></span
								>
								<template v-if="invoice.issued_return_invoice_no">
									, <a v-if="invoice.so_dn" href="javascript:;" style="padding-left:10px;" @click="gotoSO(invoice.issued_return_invoice_no, 'herp_return_so')">Return Issued SO</a>
									<!-- {{ invoice.issued_return_invoice_no }} -->
								</template>

								<template v-if="profile.use_temp_flag == 'Y' && invoice.invoice_type == 'S' && invoice.temp_flag">
									<span style="font-weight:bold;color:blue;padding-left:20px;">Ship from Georgia</span>
								</template>
							</td>
							<th>Freight Charge / Zone</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.freight_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									ref="freight_charge"
									:readonly="chargeReadonly"
									@keydown.enter.prevent="$refs.fuel_charge.$el.select()"
									@keydown.down.prevent="$refs.fuel_charge.$el.select()"
									@keydown.right.prevent="$refs.zone_code.select()"
								/>
								<input
									type="text"
									v-model.trim="invoice.zone_code"
									class="tbl_int ssm_int al_right"
									ref="zone_code"
									@keydown.down.prevent="$refs.fuel_rate_percent.$el.select()"
									@keydown.enter.prevent="$refs.fuel_rate_percent.$el.select()"
									@keydown.left.prevent="$refs.freight_charge.$el.select()"
									@keydown.right.prevent="$refs.fuel_charge.$el.select()"
								/>
							</td>
						</tr>
						<tr>
							<th>Invoice Date</th>
							<td>
								<CustomDatePicker v-model="invoice.invoice_date" :disable_future="!user.admin ? true : false" :disabled="mode == 'detail' && !user.admin && (!user.invoice_date_modifiable || !bill_partner.invoice_date_editable)" />
								S/O Date : <input type="text" class="tbl_int ssm2_int" v-model="invoice.so_date" :disabled="true" />
								<span v-if="invoice.invoice_print_dt" style="color:blue;margin-left:70px;">Printed on {{ invoice.invoice_print_dt | moment('MM-DD-YYYY HH:mm:ss') }} by '{{ invoice.invoice_print_user }}' </span>
							</td>
							<th>Fuel Charge / Rate</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.fuel_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									readonly
									ref="fuel_charge"
									@keydown.up.prevent="$refs.freight_charge.$el.select()"
									@keydown.left.prevent="$refs.zone_code.select()"
									@keydown.enter.prevent="$refs.insurance_charge.$el.select()"
									@keydown.down.prevent="$refs.insurance_charge.$el.select()"
									@keydown.right.prevent="$refs.fuel_rate_percent.$el.select()"
								/>
								<currency-input
									type="text"
									v-model="fuel_rate_percent"
									:precision="2"
									:valueRange="{ min: 0, max: 100 }"
									class="tbl_int ssm_int al_right"
									:readonly="fuelAndInsuranceChargeReadonly"
									ref="fuel_rate_percent"
									@keydown.up.prevent="$refs.zone_code.select()"
									@keydown.left.prevent="$refs.fuel_charge.$el.select()"
									@keydown.enter.prevent="$refs.insurance_rate_percent.$el.select()"
									@keydown.down.prevent="$refs.insurance_rate_percent.$el.select()"
									@keydown.right.prevent="$refs.insurance_charge.$el.select()"
								/>
								%
							</td>
						</tr>
						<tr>
							<th>Ship To</th>
							<td>
								<div style="float:left;">
									<PartnerSelect v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" ph="Ship To" :addressString="invoice.ship_to_address1" :disabled="true" />
								</div>
								<button class="gray_bt mgr_5" style="margin-left:5px;padding: 0 15px;" @click="openMemo(partner.code)">
									<font :color="partner.memo ? 'red' : 'black'">Memo</font>
								</button>
								<a v-if="invoice.ship_to_code" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoPartner(invoice.ship_to_code)">Detail</a>
							</td>
							<th>Insurance Charge / Rate</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.insurance_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									readonly
									ref="insurance_charge"
									@keydown.up.prevent="$refs.fuel_charge.$el.select()"
									@keydown.left.prevent="$refs.fuel_rate_percent.$el.select()"
									@keydown.enter.prevent="$refs.shipping_charge.$el.select()"
									@keydown.down.prevent="$refs.shipping_charge.$el.select()"
									@keydown.right.prevent="$refs.insurance_rate_percent.$el.select()"
								/>
								<currency-input
									type="text"
									v-model="insurance_rate_percent"
									:precision="2"
									:valueRange="{ min: 0, max: 100 }"
									class="tbl_int ssm_int al_right"
									ref="insurance_rate_percent"
									:readonly="fuelAndInsuranceChargeReadonly"
									@keydown.up.prevent="$refs.fuel_rate_percent.$el.select()"
									@keydown.left.prevent="$refs.insurance_charge.$el.select()"
									@keydown.right.prevent="$refs.shipping_charge.$el.select()"
									@keydown.down.prevent="$refs.shipping_charge_discount_rate_percent.$el.select()"
									@keydown.enter.prevent="$refs.shipping_charge_discount_rate_percent.$el.select()"
								/>
								%
							</td>
						</tr>
						<tr>
							<th>Bill To</th>
							<td>
								<div style="float:left;">
									<PartnerSelect v-model="invoice.bill_to_code" :initialName="invoice.bill_to_name" ph="Bill To" :disabled="true" />
								</div>
								<button class="gray_bt mgr_5" style="margin-left:5px;padding: 0 15px;" @click="openMemo(bill_partner.code)">
									<font :color="bill_partner.memo ? 'red' : 'black'">Memo</font>
								</button>
								<a v-if="invoice.bill_to_code" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoPartner(invoice.bill_to_code)">Detail</a>
								<a v-if="invoice.bill_to_code && arHistoryAccessible" href="javascript:;" type="button" class="search_bt" style="padding: 0 15px;" @click="gotoArHistory(bill_partner.code, bill_partner.name)">AR History</a>
							</td>
							<th>Shipping Charge Total</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.shipping_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									readonly
									ref="shipping_charge"
									@keydown.up.prevent="$refs.insurance_charge.$el.select()"
									@keydown.left.prevent="$refs.insurance_rate_percent.$el.select()"
									@keydown.enter.prevent="$refs.shipping_charge_discount_amount.$el.select()"
									@keydown.down.prevent="$refs.shipping_charge_discount_amount.$el.select()"
									@keydown.right.prevent="$refs.shipping_charge_discount_amount.$el.select()"
								/>
							</td>
						</tr>
						<tr>
							<th>Pay Term</th>
							<td>
								<span class="int_type_no_border mgr_10">
									<CodeSelect
										className="tbl_select"
										:codes="paymentTerms"
										v-model="invoice.payment_term_code"
										:disabled="!user.admin && !user.payment_term_modifiable"
										@set-code="setPaymentTermName"
										:fontColor="user.company_id == 'beautyplus' && invoice.payment_term_code === 'VC' ? 'blue' : 'black'"
									/>
								</span>
								<template v-if="user.company_id == 'newjigu'">
									<span style="font-weight:bold;">YTD</span>
									<currency-input type="text" v-model="partner.ytd" :precision="2" class="tbl_int ssm_int al_right mgr_5" readonly />
								</template>
							</td>
							<th>
								<font color="red">- Discount Charge / Rate</font>
							</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.shipping_charge_discount_amount"
									:precision="2"
									class="tbl_int ssm_int al_right"
									readonly
									ref="shipping_charge_discount_amount"
									@keydown.up.prevent="$refs.shipping_charge.$el.select()"
									@keydown.left.prevent="$refs.shipping_charge.$el.select()"
									@keydown.down.prevent="$refs.cod_charge.$el.select()"
									@keydown.enter.prevent="$refs.cod_charge.$el.select()"
									@keydown.right.prevent="$refs.shipping_charge_discount_rate_percent.$el.select()"
								/>
								<currency-input
									type="text"
									v-model="shipping_charge_discount_rate_percent"
									:precision="2"
									:valueRange="{ min: 0, max: 100 }"
									ref="shipping_charge_discount_rate_percent"
									class="tbl_int ssm_int al_right"
									:readonly="chargeReadonly"
									@drop.prevent=""
									@keydown.up.prevent="$refs.insurance_rate_percent.$el.select()"
									@keydown.left.prevent="$refs.shipping_charge_discount_amount.$el.select()"
									@keydown.right.prevent="$refs.cod_charge.$el.select()"
								/>
								%
							</td>
						</tr>
						<tr>
							<th>Delivery Type</th>
							<td>
								<span class="int_type_no_border mgr_10">
									<CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="invoice.delivery_type_code" @set-code="setDeliveryTypeName" />
								</span>
								<a
									v-if="invoice.invoice_type == 'S' && (invoice.status_code == 'I' || mode == 'add') && (user.company_id == 'beautyplus' || user.company_id == 'hairplus') && invoice.delivery_type_code_org != invoice.delivery_type_code"
									href="javascript:;"
									type="button"
									class="gray_bt"
									@click="updateDeliveryZone()"
									>Update Delivery Info</a
								>
								<a
									v-if="
										invoice.invoice_type == 'S' &&
											invoice.status_code == 'I' &&
											(!invoice.delivery_type_name || (!invoice.delivery_type_name.toUpperCase().startsWith('DELIVERY') && !invoice.delivery_type_name.toUpperCase().startsWith('PICKUP'))) &&
											invoice.invoice_no &&
											!invoice.has_valid_additional_so &&
											!invoice.main_invoice_no
									"
									href="javascript:;"
									type="button"
									class="search_bt"
									@click="shipment()"
									>{{ invoice.temp_flag ? 'Shipment(GA)' : 'Shipment' }}</a
								>
								<input v-if="user.company_id == 'newjigu'" type="text" class="tbl_int ssm2_int" v-model="partner.ship_info" readonly placeholder="Zone Info." />
								<!-- <font color="red">{{
									(user.company_id == 'beautyplus' || user.company_id == 'hairplus') && invoice.shipment_info_exists && invoice.cod_amount > 0 ? ' !!! Shipment with COD label exists. Void the label to modify the invoice amount.' : null
								}}</font> -->
							</td>
							<th>+ COD Charge</th>
							<td>
								<currency-input
									:disabled="cod_free"
									type="text"
									v-model="invoice.cod_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									ref="cod_charge"
									:readonly="chargeReadonly"
									@keydown.up.prevent="$refs.shipping_charge_discount_amount.$el.select()"
									@keydown.left.prevent="$refs.shipping_charge_discount_rate_percent.$el.select()"
									@keydown.enter.prevent="$refs.handling_charge.$el.select()"
									@keydown.down.prevent="$refs.handling_charge.$el.select()"
									@keydown.right.prevent="$refs.handling_charge.$el.select()"
								/>
							</td>
						</tr>
						<tr>
							<th>Ship Charge</th>
							<td>
								<span class="int_type_no_border mgr_10">
									<CodeSelect className="tbl_select" :codes="shipCharges" fontColor="red" v-model="invoice.ship_charge_code" :disabled="!user.admin && !user.ship_charge_modifiable" @set-code="setShipChargeName" />
								</span>
								<template v-if="user.company_id == 'newjigu'">
									<input class="tbl_int sm_int" type="text" v-model="partner.telephone" readonly />
									<input class="tbl_int sm_int" type="text" v-model="partner.telephone2" readonly />
								</template>
							</td>
							<th>+ Handling Charge</th>
							<td>
								<currency-input
									:disabled="handling_charge_free"
									type="text"
									v-model="invoice.handling_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									ref="handling_charge"
									:readonly="chargeReadonly"
									@keydown.up.prevent="$refs.cod_charge.$el.select()"
									@keydown.left.prevent="$refs.cod_charge.$el.select()"
									@keydown.enter.prevent="$refs.special_discount.$el.select()"
									@keydown.down.prevent="$refs.special_discount.$el.select()"
									@keydown.right.prevent="$refs.special_discount.$el.select()"
								/>
							</td>
						</tr>
						<tr>
							<th>Boxed By</th>
							<td>
								<input type="text" v-model.trim="invoice.packed_user" class="tbl_int sm_int" :disabled="true" />
								<button v-if="user.company_id == 'hairplus' || user.company_id == 'arkin'" @click="pickUser()">...</button>
								, <b class="mgl_15">Invoiced By</b><input type="text" v-model.trim="invoice.invoiceCreatorName" class="mgl_15 tbl_int sm_int" :disabled="true" />
							</td>
							<th>
								<font color="red">- Special Discount</font>
							</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.special_discount"
									:precision="2"
									class="tbl_int ssm_int al_right"
									ref="special_discount"
									:readonly="chargeReadonly"
									@keydown.up.prevent="$refs.handling_charge.$el.select()"
									@keydown.left.prevent="$refs.handling_charge.$el.select()"
									@keydown.enter.prevent="$refs.total_charge.$el.select()"
									@keydown.down.prevent="$refs.total_charge.$el.select()"
									@keydown.right.prevent="$refs.total_charge.$el.select()"
								/>
							</td>
						</tr>
						<tr>
							<th>To Accounting</th>
							<td>
								<input type="text" v-model.trim="invoice.remark" class="tbl_int red_bold" />
								<!-- <div style="float:left;"><input type="text" v-model.trim="invoice.remark" class="tbl_int" /></div> -->
								<!-- <div style="float:left;padding-left:5px;">
									<CodeSelect className="tbl_select" :codes="remarks" :width="60" :showDesc="false" v-model="remark" />
								</div> -->
							</td>
							<th>{{ invoice.invoice_type == 'S' ? '+ Bounce Fee' : invoice.invoice_type == 'R' ? '+ Restock Fee' : '' }} / Add'l C.</th>
							<td>
								<currency-input v-show="invoice.invoice_type == 'S'" type="text" v-model="invoice.bounce_fee" :precision="2" class="tbl_int ssm_int al_right" readonly />
								<currency-input v-show="invoice.invoice_type == 'R'" type="text" v-model="invoice.restock_fee" :precision="2" class="tbl_int ssm_int al_right" :readonly="chargeReadonly" />
								<currency-input type="text" v-model="invoice.other_charge" :precision="2" class="tbl_int ssm_int al_right" :readonly="chargeReadonly" />
							</td>
						</tr>
						<tr>
							<th>To Customer</th>
							<td>
								<input type="text" v-model.trim="invoice.description" class="tbl_int" placeholder="To Customer" />
							</td>
							<th>
								<font color="blue">Charge Total</font>
							</th>
							<td>
								<currency-input
									type="text"
									v-model="invoice.total_charge"
									:precision="2"
									class="tbl_int ssm_int al_right"
									readonly
									ref="total_charge"
									@keydown.left.prevent="$refs.special_discount.$el.select()"
									@keydown.up.prevent="$refs.special_discount.$el.select()"
								/>
							</td>
						</tr>
						<tr v-if="user.company_id == 'hairplus'">
							<th>General Remark</th>
							<td>
								<input type="text" v-model.trim="invoice.general_remark" class="tbl_int" placeholder="General Remark" />
							</td>
						</tr>
						<tr>
							<th>Qty/Amt<span v-if="user.company_id == 'beautyplus'"> (Original)</span></th>
							<td>
								<!-- <money type="text" v-model="invoice.quantity" class="tbl_int ssm_int al_right" readonly /> -->
								<currency-input type="text" v-model="invoice.total_shipped_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="invoice.total_shipped_amount" class="tbl_int ssm_int al_right" readonly />
								<template v-if="user.company_id == 'beautyplus'">
									(
									<currency-input type="text" v-model="invoice.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
									<currency-input type="text" v-model="invoice.total_amount" class="tbl_int ssm_int al_right" readonly />
									)
								</template>
								, Box Count :
								<currency-input type="text" v-model="invoice.box_count" :precision="0" class="tbl_int sssm_int al_right" readonly />
								, Box Total LB :
								<currency-input type="text" v-model="invoice.total_weight" :precision="0" :allow-negative="false" class="tbl_int sssm_int al_right" :readonly="totalWeightReadonly" @input.native="onTotalWeightInput" @change="onTotalWeightChange" />
								<a v-if="!totalWeightReadonly && invoice.manual_total_weight != null" href="javascript:;" type="button" class="gray_bt mgl_5" @click="useAutoTotalWeight()">Use Auto</a>
								<!-- <a v-if="mode == 'detail' && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="reboxing()">Re Boxing</a> -->
								<a v-if="invoice.invoice_no && invoice.invoice_type == 'S'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="reboxing()">Re Boxing</a>
							</td>
							<th>
								<font color="blue">+ Sales Order Total</font>
							</th>
							<td>
								<currency-input type="text" v-model="invoice.total_shipped_amount" :precision="2" class="tbl_int ssm_int al_right" readonly />
							</td>
						</tr>
						<tr>
							<th>Customer PO No</th>
							<td>
								<input type="text" class="tbl_int sm_int mgr_15" v-model="invoice.customer_po_no" />

								<b class="mgl_15 pdl_20">
									<template v-if="user.company_id === 'jc'"> Ship/PickUp Date</template>
									<template v-else> Pick up Date(Delivery)</template>
								</b>
								<CustomDatePicker class="mgr_10" v-model="invoice.delivery_pick_up_date" :disabled="!modifiable" />
								<b>
									<template v-if="user.company_id === 'jc'"> Ship/PickUp User</template>
									<template v-else> Pick up User(Delivery)</template>
								</b>
								<span class="int_type_no_border mgr_10">
									<CodeSelect className="tbl_select" :codes="converted_salesmans" v-model="invoice.delivery_pick_up_user" :disabled="!modifiable" />
								</span>
							</td>
						</tr>
						<tr>
							<th>
								<label for="International"> <input type="checkbox" id="International" v-model="invoice.international" /> International </label>
							</th>
							<td>
								<template v-if="invoice.international">
									<label class="mgr_5"><input type="radio" value="1" v-model="invoice.price_rate" /> 100 %</label>
									<label class="mgr_5"><input type="radio" value="0.75" v-model="invoice.price_rate" /> 75 %</label>
									<label class="mgr_10"><input type="radio" value="0.5" v-model="invoice.price_rate" /> 50 %</label>
								</template>
								<label for="reshipped"> <input type="checkbox" id="reshipped" v-model="invoice.reshipped_yn" true-value="Y" false-value="N" /> <b>Reshipped</b> </label>
								<label for="shipped" style="margin-left:10px;margin-right:10px;"> <input type="checkbox" id="shipped" v-model="invoice.shipped" /> <b>Shipped</b> </label>
								<input type="text" v-model.trim="invoice.shipping_info" class="tbl_int lm_int" placeholder="Shipping Information" />
							</td>
							<th>
								<font color="blue"
									><b><span v-if="invoice.international">(Adj)</span> Computed / Stored Inv. Amt.</b>
								</font>
							</th>
							<td>
								<currency-input type="text" v-model="invoice.invoice_amount" style="font-weight:bold;" :precision="2" class="tbl_int ssm_int al_right" readonly />
								<currency-input type="text" v-model="stored_invoice_amount" style="" :precision="2" class="tbl_int ssm_int al_right" readonly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-show="user.company_id == 'newjigu'" class="mgb_10 divide_tbl">
				<table border="0">
					<tr>
						<td style="width:1000px;" valign="top">
							<table class="list_tbl mgb_0" id="prev_invoice" border="0">
								<thead>
									<tr>
										<th style="width:110px;">SO No</th>
										<th style="width:85px;">SO Date</th>
										<th style="width:40px;">Status</th>
										<th style="width:80px;">SO Amt.</th>
										<th style="width:110px;">Inv. No</th>
										<th style="width:85px;">Inv. Date</th>
										<th style="width:80px;">Inv. Amt.</th>
										<th style="width:80px;">Balance</th>
										<th>To Accounting</th>
										<th>{{ user.company_id == 'newjigu' ? 'General Remark' : 'To Customer' }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="prevInvoice in prevInvoices.slice(0, 4)" v-bind:key="prevInvoice.invoice_no">
										<td class="al_left">
											<a href="javascript:;" @click="selectPrevSO(prevInvoice)">{{ prevInvoice.so_dn }}</a>
										</td>
										<td class="al_left">{{ prevInvoice.so_date }}</td>
										<td class="al_center">{{ prevInvoice.status_code }}</td>
										<td class="al_right">{{ prevInvoice.total_amount | toCurrency }}</td>
										<td class="al_left">
											<a href="javascript:;" @click="selectPrevInvoice(prevInvoice)">{{ prevInvoice.invoice_dn }}</a>
										</td>
										<td class="al_left">
											<span v-if="prevInvoice.status_code == 'I'">{{ prevInvoice.invoice_date }}</span>
										</td>
										<td class="al_right">{{ prevInvoice.invoice_amount | toCurrency }}</td>
										<td class="al_right">{{ prevInvoice.balance | toCurrencyZeroNull }}</td>
										<td class="al_left truncate">
											<span :title="prevInvoice.remark">{{ prevInvoice.remark }}</span>
										</td>
										<td class="al_left truncate">
											<template v-if="user.company_id == 'newjigu'">
												<span :title="prevInvoice.general_remark">{{ prevInvoice.general_remark }}</span>
											</template>
											<template v-else>
												<span :title="prevInvoice.description">{{ prevInvoice.description }}</span>
											</template>
										</td>
									</tr>
									<template v-if="prevInvoices.length < 4">
										<tr v-for="item in 4 - prevInvoices.length" v-bind:key="item">
											<td v-for="dummy in 10" v-bind:key="dummy">&nbsp;</td>
										</tr>
									</template>
								</tbody>
							</table>

							<div class="recent_bottom_box" style="height:45px;">
								<div class="left_bt">
									<span id="recent_invoice_count" style="text-align:right;color:red;">{{ prevInvoicesCount }}</span>
									inv. / B. Total
									<currency-input type="text" disabled class="tbl_int al_right" style="width: 90px;font-weight:bold;color:red;" v-model="prevInvoicesBalanceSum" />
								</div>

								<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
							</div>
						</td>
						<td style="width:200px;padding-left:20px;" valign="top">
							<table class="list_tbl mgb_0" id="post_check_list" border="0">
								<thead>
									<tr>
										<th>Post Check Date</th>
										<th>Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="check in postChecks.slice(0, 4)" v-bind:key="check.post_check_date">
										<td class="al_left">{{ check.post_check_date }}</td>
										<td class="al_right">{{ check.amount | toCurrency }}</td>
									</tr>
									<tr>
										<td class="al_right">Total Post Check Count</td>
										<td class="al_right">{{ postChecks.length }}</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</table>
			</div>

			<div class="view_bottom_bt" v-if="user.company_id == 'newjigu'">
				<a v-if="modifiable && invoice.invoice_type == 'S' && invoice.status_code == 'I' && this.mode == 'detail'" href="javascript:;" type="button" class="gray_bt" style="float:left;" @click="makeReturnSO()">All Return</a>
				<a v-if="modifiable && !invoice.has_valid_additional_so && !invoice.main_invoice_no" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable && !invoice.has_valid_additional_so && !invoice.main_invoice_no" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>
				<a href="javascript:;" type="button" class="gray_bt mgr_15" @click="viewHistory()">History</a>
				<template v-if="invoice.status_code == 'I'">
					<a v-if="user.invoice_void || user.admin_yn == 'Y'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateInvoiceVoid('VI')">Void</a>
				</template>
				<template v-else-if="invoice.status_code == 'VI'">
					<a v-if="user.invoice_void || user.admin_yn == 'Y'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateInvoiceVoid('I')">Revive</a>
				</template>

				<a v-if="this.mode === 'add' && this.invoice.status_code === 'W'" href="javascript:void(0);" type="button" class="gray_bt" @click="printProfoma()">Proforma Inv.</a>
				<!-- <a v-if="this.mode !== 'add' && user.company_id === 'newjigu'" href="javascript:void(0);" type="button" class="gray_bt" @click="excelExportForItems()">Excel(Items)</a> -->
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="excelExportForItems()">Excel(Items)</a>
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="print()">Print</a>
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="mail()">EMail</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="cancel()">Cancel</a>
			</div>

			<table class="list_tbl mgb_0 add_top_line" ref="invoice_items">
				<thead>
					<tr>
						<th width="8%">{{ headers.class }}</th>
						<th v-if="invoice.international" width="12%">Description of Goods</th>
						<th><a href="javascript:;" @click="sortName()">Name</a></th>
						<th v-if="user.company_id != 'jc'" width="10%">Color</th>
						<th width="5%">Price</th>
						<th v-if="invoice.international" width="5%">Adj. P</th>
						<th width="5%">Ord. Qty</th>
						<th width="5%">
							<template v-if="user.company_id == 'beautyplus' && invoice.invoice_type == 'S' && invoice.status_code == 'I' && invoice.shipment_info_exists"></template>
							<template v-else> <input type="checkbox" @change="selectAll()" v-model="allSelected"/></template>
							Inv. Qty
						</th>
						<th width="6%">Amount</th>
						<th v-if="invoice.international" width="6%">Adj. Amt.</th>
						<th width="5%"><span v-if="invoice.invoice_type == 'S'">Scant Qty.</span></th>
						<!-- <th width="7%"><input type="checkbox" v-model="allSelected" @change="addAllToBackOrder()" /> Back Order</th> -->
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in getItems()" v-bind:key="item.invoice_item_no" @dblclick="dblclickItem(item)">
						<td class="al_left">
							<!-- {{ item.class_code }} -->
							<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
								{{ item.class_code }}
							</template>
						</td>
						<td v-if="invoice.international" class="al_left">{{ item.class_group_description }}</td>
						<td class="al_left" :style="item.scant_quantity > 0 ? 'background-color: yellow;' : ''">
							<a href="javascript:;" @click="selectItem(item)">{{ item.name }}</a>
							<!-- {{ tindex + '_' + item.invoice_item_no }} -->
						</td>
						<td v-if="user.company_id != 'jc'" class="al_left" :style="item.scant_quantity > 0 ? 'background-color: yellow;' : ''">
							<a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}</a>
						</td>
						<td class="al_right">{{ item.unit_price | toCurrency }}</td>
						<td v-if="invoice.international" class="al_right">{{ (item.unit_price * invoice.price_rate) | toCurrency }}</td>
						<td class="al_right">
							{{ item.quantity_abs }}
						</td>
						<td class="al_right">
							<!-- {{ item.shipped_quantity }} -->
							<template v-if="user.company_id == 'beautyplus' && invoice.invoice_type == 'S' && invoice.status_code == 'I' && invoice.shipment_info_exists">
								{{ item.shipped_quantity_abs }}
							</template>
							<template v-else>
								<currency-input
									type="text"
									v-model.trim="item.shipped_quantity_abs"
									:value-range="{ min: 0, max: item.max_quantity }"
									:precision="0"
									:style="item.shipped_quantity_abs > item.quantity_abs ? 'color:red;' : 'color:black'"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="shipped_quantity"
									@keydown.down.prevent="goTo('shipped_quantity', index + 1, 1)"
									@keydown.up.prevent="goTo('shipped_quantity', index - 1, -1)"
									@keydown.enter.prevent="goTo('shipped_quantity', index + 1, 1)"
								/>
							</template>
						</td>
						<td class="al_right">{{ item.shipped_amount | toCurrency }}</td>
						<td v-if="invoice.international" class="al_right">{{ (item.shipped_quantity * item.unit_price * invoice.price_rate) | toCurrency }}</td>
						<td class="al_right" :style="item.scant_quantity > 0 ? 'background-color: yellow;' : ''">{{ item.scant_quantity > 0 ? item.scant_quantity : null | commaSeparated }}</td>
					</tr>
				</tbody>
			</table>

			<div class="view_bottom_bt">
				<a v-if="modifiable && invoice.invoice_type == 'S' && invoice.status_code == 'I' && this.mode == 'detail'" href="javascript:;" type="button" class="gray_bt" style="float:left;" @click="makeReturnSO()">All Return</a>

				<a v-if="modifiable && !invoice.has_valid_additional_so && !invoice.main_invoice_no" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<!-- <a
					v-if="modifiable && ((user.company_id != 'beautyplus' && user.company_id != 'hairplus') || !invoice.shipment_info_exists) && !invoice.has_valid_additional_so && !invoice.main_invoice_no"
					href="javascript:;"
					type="button"
					class="search_bt"
					@click="save(false)"
					>Save & Return</a
				> -->
				<a v-if="modifiable && !invoice.has_valid_additional_so && !invoice.main_invoice_no" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>
				<!-- <a
					v-if="modifiable && ((user.company_id != 'beautyplus' && user.company_id != 'hairplus') || !invoice.shipment_info_exists) && !invoice.has_valid_additional_so && !invoice.main_invoice_no"
					href="javascript:;"
					type="button"
					class="search_bt mgr_15"
					@click="save(true)"
					>Save Only</a
				> -->

				<a href="javascript:;" type="button" class="gray_bt mgr_15" @click="viewHistory()">History</a>

				<!-- <template v-if="invoice.status_code == 'I' && ((user.company_id != 'beautyplus' && user.company_id != 'hairplus') || !invoice.shipment_info_exists)"> -->
				<template v-if="invoice.status_code == 'I'">
					<a v-if="user.invoice_void || user.admin_yn == 'Y'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateInvoiceVoid('VI')">Void</a>
				</template>
				<template v-else-if="invoice.status_code == 'VI'">
					<a v-if="user.invoice_void || user.admin_yn == 'Y'" href="javascript:;" type="button" class="gray_bt mgr_15" @click="updateInvoiceVoid('I')">Revive</a>
				</template>

				<a v-if="this.mode === 'add' && this.invoice.status_code === 'W' && user.company_id === 'newjigu'" href="javascript:void(0);" type="button" class="gray_bt" @click="printProfoma()">Proforma Inv.</a>
				<!-- <a v-if="this.mode !== 'add' && user.company_id === 'newjigu'" href="javascript:void(0);" type="button" class="gray_bt" @click="excelExportForItems()">Excel(Items)</a> -->
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="excelExportForItems()">Excel(Items)</a>
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="print()">Print</a>
				<a v-if="this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="mail()">EMail</a>
				<a v-if="user.company_id == 'hairplus' && this.mode !== 'add'" href="javascript:void(0);" type="button" class="gray_bt" @click="openArSmsModal">SMS</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="cancel()">Cancel</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'History'" :draggable="false">
			<template slot="title">Sales Order / Invoice History</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div :style="user.company_id == 'beautyplus' || user.company_id == 'hairplus' ? 'width:1650px; height:900px;' : 'width:1350px; height:700px;'" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="145px;">Update Date Time</th>
								<th width="120px;">Status</th>
								<th width="90px;">Ship To</th>
								<th width="115px;">Payment Term</th>
								<th width="125px;">Ship Charge</th>
								<th width="120px;">Delivery Type</th>
								<th width="80px;">From Amt.</th>
								<th width="80px;">To Amt.</th>
								<th width="120px;">User</th>
								<th v-if="user.company_id == 'beautyplus'" width="55px;">Source</th>
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<th width="70px;">Picker</th>
									<th width="70px;">Pickup Start</th>
									<th width="70px;">Pickup End</th>
									<th width="70px;">Packer</th>
									<th width="70px;">Packed DT</th>
								</template>
								<th width="90px;">View Items</th>
								<th>Update Remark</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(history, index) in histories" v-bind:key="history.invoice_history_no">
								<td class="al_left">{{ history.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td class="al_left">
									<span v-if="history.auto_approved && history.status_code == 'A'"> <font color="blue">Pre</font>- </span>{{ history.status_code | saleStatusName }}
									<span v-if="history.designated" style="color:gray;">(D)</span>
								</td>
								<td class="al_left">{{ history.ship_to_code }}</td>
								<td class="al_left">{{ history.payment_term_name }}</td>
								<td class="al_left">{{ history.ship_charge_name }}</td>
								<td class="al_left">{{ history.delivery_type_name }}</td>
								<td class="al_right">{{ history.status_code == 'I' ? history.from_invoice_amount : history.from_total_amount | toCurrency }}</td>
								<td class="al_right">{{ history.status_code == 'I' ? history.to_invoice_amount : history.to_total_amount | toCurrency }}</td>
								<td class="al_left">{{ history.crt_name }}</td>
								<td v-if="user.company_id == 'beautyplus'" class="al_left">
									<template v-if="history.status_code == 'O'">{{ history.source | sourceClient }}</template>
								</td>
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.picker_id != histories[index - 1].picker_id)">
											{{ history.picker_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_start_dt != histories[index - 1].pickup_start_dt)">
											{{ history.pickup_start_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_end_dt != histories[index - 1].pickup_end_dt)">
											{{ history.pickup_end_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_user != histories[index - 1].packed_user)">
											{{ history.packer_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_dt != histories[index - 1].packed_dt)">
											{{ history.packed_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
								</template>
								<td class="al_left"><a href="javascript:;" @click="viewHistoryItems(history)" class="outstanading">View Items</a></td>
								<td class="al_left truncate" :title="history.update_remark">{{ history.update_remark }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModalItems" v-if="showModal && modalName == 'HistoryItems'" :draggable="false">
			<!-- <template slot="title">Sales Order History Items</template> -->
			<template slot="title">Items</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div style="width:1000px; height:800px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th v-if="modalName == 'PrevInvoiceItems'" style="text-align:center;width:3%;"><input type="checkbox" @change="selectAllPreviousInvoiceItems()" v-model="allPreviousItemsSelected" /></th>
								<th width="10%">{{ headers.class }}</th>
								<th>Name</th>
								<th width="10%">Color</th>
								<th width="7%">Price</th>
								<th width="6%">{{ invoice.invoice_type == 'R' ? 'Return' : 'Order' }}</th>
								<th width="7%">Amount</th>
								<th width="6%">{{ invoice.invoice_type == 'R' ? 'Conf.' : 'Shipped' }}</th>
								<th width="7%">Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in popup_items" v-bind:key="item.invoice_item_no">
								<td v-if="modalName == 'PrevInvoiceItems'" class="al_center"><input type="checkbox" v-model="item.selected" /></td>
								<td class="al_left">{{ item.class_code }}</td>
								<td class="al_left">
									<b v-if="item.active_yn == 'N'"> <font color="red">!!</font> </b>{{ item.name }}
								</td>
								<td class="al_left">{{ item.color_code }}</td>
								<td class="al_right">{{ item.unit_price | toCurrency }}</td>
								<td class="al_right">{{ item.quantity_abs | commaSeparated }}</td>
								<td class="al_right">{{ item.amount | toCurrency }}</td>
								<td class="al_right">{{ item.shipped_quantity_abs | commaSeparated }}</td>
								<td class="al_right">{{ item.shipped_amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a v-if="modalName == 'PrevInvoiceItems' && user.so_imv && invoice.invoice_type == 'S'" href="javascript:;" @click="importItemsAndMakeVoid()" class="search_bt">Import and Make Void</a>
						<a v-if="modalName == 'PrevInvoiceItems'" href="javascript:;" @click="importItems()" class="search_bt">Import Only</a>
						<a href="javascript:;" @click="closeModalItems()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Shipment'" :draggable="false" :showCloseButton="false">
			<template slot="title">Shipment</template>
			<template slot="body">
				<!-- <ShipmentPopup :invoice="invoice" @close="closeModal()" @closeWithReturn="checkShipmentCharge" /> -->
				<ShipmentPopup ref="shipmentPopup" :invoice="invoice" @close="closeModal()" @closeWithReturn="checkShipmentCharge" @apply-invoice-freight-charge="applyInvoiceFreightCharge" @set-shipment-exists="setShipmentExists" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ShipmentTemp'" :draggable="false" :showCloseButton="false">
			<template slot="title">Shipment (Ship from Georgia)</template>
			<template slot="body">
				<!-- <ShipmentPopup :invoice="invoice" @close="closeModal()" @closeWithReturn="checkShipmentCharge" /> -->
				<ShipmentPopupTemp ref="shipmentPopup" :invoice="invoice" @close="closeModal()" @closeWithReturn="checkShipmentCharge" @apply-invoice-freight-charge="applyInvoiceFreightCharge" @set-shipment-exists="setShipmentExists" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'UserSelect'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select User(s)</template>
			<template slot="body">
				<UserPopup v-on:close="closeModal()" :initialDeptCode="'9000'" :displaySearchCondition="false" @set-users="setUsers" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Update'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Update Remark</template>
			<template slot="body">
				<UpdatePopup v-on:close="closeModal()" :update_remarks="update_remarks" @update-remark-call-back="updateRemarkConfirm" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<!-- <MemoPopup :partner_code="partner.code" v-on:close="closeModal($event)" /> -->
				<MemoPopup :partner_code="partner_code_for_memo" v-on:close="closeModal($event)" />
			</template>
		</Modal>

		<Modal @close="closeArSmsModal" v-if="showModal && modalName === 'AR_SMS'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">AR SMS</template>
			<template slot="body">
				<table class="view_tbl" border="0" style="width: 600px;">
					<colgroup>
						<col style="width:80px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="width:500px;" />
					</colgroup>
					<tbody>
						<tr>
							<th>Tel. SMS</th>
							<td>
								<input type="text" v-model.trim="sms_rcpt_number" class="tbl_int" />
							</td>
						</tr>
						<tr>
							<th></th>
							<td>
								<span style="color: red;"> SMS is sent within the US only,<br />Please be sure to exclude the international code (+1) from this phone number. </span>
							</td>
						</tr>
						<tr>
							<th>Content</th>
							<td>
								<div class="mc_textarea">
									<label>
										<textarea rows="12" name="content" v-model.trim="sms_body"></textarea>
									</label>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="popup_bottom">
					<a href="javascript:void(0);" @click="sendArSms" class="search_bt mgr_15">Send</a>
					<a href="javascript:void(0);" @click="closeArSmsModal" class="gray_bt">Close</a>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import _ from 'lodash';
import { inputSelectOnClick } from '@/utils/etc.js';
import {
	apiInvoicePrintData,
	apiSelectDeliveryTypeChangeHistory,
	apiSelectInvoice,
	apiSelectInvoiceHistoryItemList,
	apiSelectInvoiceItemList,
	apiSelectInvoiceList,
	apiSoIndex,
	apiSubmitInvoiceAfterBoxing,
	apiUpdateInvoicePrint,
	apiUpdateInvoiceVoid,
	apiUpdateZoneCode,
} from '@/api/sales/invoice.js';
import { apiSelectBoxInformation } from '@/api/sales/boxing.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import Modal from '@/components/common/Modal';
import ShipmentPopup from '@/components/common/ShipmentPopup';
import ShipmentPopupTemp from '@/components/common/ShipmentPopupTemp';
import MemoPopup from '@/components/common/MemoPopup';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import UpdatePopup from '@/components/common/UpdatePopup.vue';
import Paging from '@/components/common/Paging';
import { getDayOfWeek, isInThePast, toDate, today, toText } from '@/utils/date.js';
//import { getPossibleStatus } from '@/main.js';
import SoSelect from '@/components/common/SoSelect';
import UserPopup from '@/components/common/UserPopup';

import 'floatthead';
import { apiGetBase64ReportTemplate, apiGetReportTemplate, companyMrtUrl, exportDataExcel, PrintType, Report } from '@/api/util';
import { apiSelectUserList } from '@/api/basicinfo/user';
import { apiGetArSmsBody, apiSendArSms } from '@/api/receipt/index.js';
import { apiSelectPartner } from '@/api/partner';
import { defaultDataType } from 'export-xlsx';

export default {
	beforeRouteLeave(to, from, next) {
		// console.log(this.invoice.check_shipment_email, this.bill_partner.email);
		// if (this.invoice.check_shipment_email && this.bill_partner.email) return;

		//console.log(this.save_complete, this.invoice.invoice_amount.toFixed(2), this.stored_invoice_amount.toFixed(2));
		//if (this.mode == 'add' || this.save_complete || (this.invoice.invoice_amount == this.stored_invoice_amount && !this.isChargeChanged())) next();
		if (!this.invoice.invoice_amount) next();
		//유효하지 않은 것이므로 체크 불필요
		else if (this.mode == 'add' || this.save_complete || this.invoice.invoice_amount.toFixed(2) == this.stored_invoice_amount.toFixed(2)) next();
		//charge 변경건은 체크하지 않음
		else if (this.invoice.invoice_type == 'R' && this.invoice.invoice_amount.toFixed(2) == this.stored_invoice_amount.toFixed(2)) next();
		else {
			if (confirm('Some of Invoice Information (including charges) Changed. Are you leaving without saving change(s)?')) next();
			else next(false);
		}
	},
	props: ['headers'],
	data: function() {
		return {
			backUri: '/sales/invoice_main',
			mode: 'add',
			// #3140 Box Total LB: 사용자가 실제로 타이핑했을 때만 수동값으로 인정하기 위한 플래그.
			// (currency-input 이 로드 시 소수점 반올림하며 change 를 발생시키므로 그것만으로는 수동값이 되면 안 된다)
			total_weight_touched: false,
			invoice: {
				delivery_type_name: '',
			},
			partner: {},
			bill_partner: {},
			items: [],
			item_nos_to_delete: [],

			paging_yn: 'Y',
			page_size: 4,
			page_no: 1,
			list_count: 0,

			prevInvoices: [],
			prevInvoicesCount: 0,
			prevInvoicesBalanceSum: 0,
			postChecks: [],
			//docs: [],

			// itemSearchOptions: {},

			businessTypes: [],
			grades: [],
			races: [],
			deliveryTypes: [],
			shipCharges: [],
			salesGroups: [],
			salesmans: [],
			paymentTerms: [],
			remarks: [],
			specialSales: [],
			recipetTypes: [],
			arTypes: [],
			docTypes: [],
			saleStatusCodes: [],
			doc_type_code: null,
			doc_type_name: null,

			remark: null,

			allSelected: false,
			allSelected2: false,

			itemClass: null,
			keyword: '',
			searchItems: [],

			histories: [],

			boxes: [],

			//shipment: {},
			// depts: [],
			// salesTeams: [],

			// userTypes: [
			// 	{ value: 'staff', text: 'Office' },
			// 	{ value: 'salesman', text: 'Salesman' },
			// 	{ value: 'driver', text: 'Driver' },
			// 	{ value: 'whstaff', text: 'Warehouse Staff' },
			// ],

			modalName: '',
			prevModalName: '',
			showModal: false,

			profile: null,

			cod_free: false,
			handling_charge_free: false,

			stored_invoice_amount: null,
			stored_invoice: {},

			load_complete: false,
			save_complete: false,

			initialStatusCode: 'W',
			initialFromDaysAgo: 3,

			update_remarks: ['Regular Saving Without a Change', 'Charging Shipping Cost', 'Modifying Delivery Type', 'Modifying Payment Term', 'Changing Item Quantity', 'Reshipping'],
			temp_stay: true,

			sms_body: null,
			sms_rcpt_number: null,
		};
	},
	computed: {
		fuel_rate_percent: {
			get: function() {
				return this.invoice.fuel_rate * 100;
			},
			set: function(newValue) {
				//this.invoice.fuel_rate = parseFloat((newValue / 100).toFixed(2));
				this.invoice.fuel_rate = newValue / 100;
			},
		},
		insurance_rate_percent: {
			get: function() {
				return this.invoice.insurance_rate * 100;
			},
			set: function(newValue) {
				//this.invoice.insurance_rate = parseFloat((newValue / 100).toFixed(2));
				this.invoice.insurance_rate = newValue / 100;
			},
		},
		shipping_charge_discount_rate_percent: {
			get: function() {
				//console.log('get', this.invoice.shipping_charge_discount_rate * 100);
				return this.invoice.shipping_charge_discount_rate * 100;
			},
			set: function(newValue) {
				//console.log('set', newValue);
				this.invoice.shipping_charge_discount_rate = newValue / 100;
				//console.log(this.invoice.shipping_charge);
				//console.log(this.invoice.shipping_charge * this.invoice.shipping_charge_discount_rate);
				//console.log(parseFloat(this.invoice.shipping_charge * this.invoice.shipping_charge_discount_rate.toFixed(2)));
				this.invoice.shipping_charge_discount_amount = parseFloat(this.invoice.shipping_charge * this.invoice.shipping_charge_discount_rate.toFixed(2));
			},
		},
		arHistoryAccessible() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if (menus[i].path == '/receipt/ar_history' && menus[i].view_yn == 'Y') return true;
			}
			return false;
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}

			return false;
		},
		fuelAndInsuranceChargeReadonly() {
			if (this.user.company_id == 'arkin') return false;
			return true;
		},
		totalWeightReadonly() {
			// #3140 jc 의 Sales Invoice 에 한해 Box Total LB 수동 입력 허용 (그 외 고객사는 기존대로 읽기전용)
			if (this.user.company_id != 'jc') return true;
			if (this.invoice.invoice_type != 'S') return true;
			return !this.modifiable;
		},
		chargeReadonly() {
			if (this.user.company_id == 'newjigu' && isInThePast(this.invoice.invoice_date)) return true;
			// console.log(isInThePast('06-01-2022'));

			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		converted_salesmans() {
			return this.salesmans.map(el => ({ code: el.user_id, name: el.name }));
		},
		fedexAccountChanged() {
			let res = false;

			if (Array.isArray(this.histories)) {
				const delivery_type_name = this.invoice.delivery_type_name ? this.invoice.delivery_type_name.toUpperCase() : '';
				const accounts = [];
				this.histories.forEach(el => {
					if (!accounts.includes(el.ship_to_code)) accounts.push(el.ship_to_code);
				});

				res = delivery_type_name.indexOf('FEDEX') > -1 && accounts.length > 1;
			}

			return res;
		},
	},
	watch: {
		invoice: {
			deep: true,
			handler: function() {
				if (!this.load_complete) return;
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		PartnerSelect,
		Modal,
		ShipmentPopup,
		ShipmentPopupTemp,
		CodeSelect,
		CustomDatePicker,
		SoSelect,
		UserPopup,
		UpdatePopup,
		MemoPopup,
		Paging,
	},
	methods: {
		async openArSmsModal() {
			const sms_response = await apiGetArSmsBody(this.invoice.invoice_no);
			const cust_response = await apiSelectPartner({ code: this.invoice.bill_to_code });

			const body = sms_response.data;
			const rcpt_number = cust_response.data && cust_response.data.partner ? cust_response.data.partner.telephone_sms : null;

			this.modalName = 'AR_SMS';
			this.sms_body = body;
			this.sms_rcpt_number = rcpt_number;
			this.showModal = true;
		},
		async sendArSms() {
			if (!this.sms_rcpt_number) {
				this.$toast.error('Empty Telephone Number.');
				return;
			}
			if (!this.sms_body) {
				this.$toast.error('Empty Content.');
				return;
			}

			const { data } = await apiSendArSms(this.invoice.invoice_no, this.invoice.bill_to_code, this.sms_rcpt_number, this.sms_body);
			if (data.result) {
				this.$toast.success('Success to Send SMS.');
				this.closeArSmsModal();
			} else {
				this.$toast.error(data.msg);
			}
		},
		closeArSmsModal() {
			this.modalName = null;
			this.sms_body = null;
			this.sms_rcpt_number = null;
			this.closeModal();
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.loadPreviouseInvoices(this.invoice.ship_to_code, pageNo);
		},
		async gotoPartner(partner_code) {
			let routeData = this.$router.resolve({ name: 'partnerDetail', query: { backUri: this.uri, code: partner_code }, params: { mode: 'detail' } });
			window.open(routeData.href, 'herp_partner');
		},
		async gotoArHistory(partner_code, partner_name) {
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.uri, bill_to_code: partner_code, bill_to_name: partner_name } });
			window.open(routeData.href, 'herp_ar_history');
		},
		openMemo(partner_code) {
			this.partner_code_for_memo = partner_code;
			this.openModal('Memo');
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			if (this.modalName.startsWith('Shipment') && this.invoice.check_shipment_email && this.bill_partner.email && (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development')) {
				//if (this.invoice.check_shipment_email && this.bill_partner.email) {
				// if (this.bill_partner.email) {
				// this.$toast.info("A shipment label has been created, and the customer's email address is available. Please don't forget to send the email to the customer.", { duration: 15000 });
				this.invoice.check_shipment_email = false;
				// if (confirm('Shall I email the customer with the shipping information?')) {
				// 	this.mail();
				// 	return;
				// }
				// }
			}
		},
		getItems() {
			return this.items;
		},
		async updateDeliveryZone() {
			const { data } = await apiUpdateZoneCode(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
				this.invoice.delivery_type_code_org = this.invoice.delivery_type_code;

				this.setDefaultCharges();
				alert('Check Ship Charge');
				//this.$forceUpdate();
			} else {
				this.$toast.error(data.msg);
			}
		},
		applyInvoiceFreightCharge(apiCharge) {
			if (this.invoice.freight_charge != apiCharge) {
				this.invoice.freight_charge = apiCharge;
				this.submit(true, 'Charging Shipping Cost', true);
			} else {
				this.$toast.error('Charge was not changed.');
			}
		},
		setShipmentExists(shipment_exists) {
			if (!this.invoice.shipment_info_exists && shipment_exists) this.invoice.check_shipment_email = true;

			this.invoice.shipment_info_exists = shipment_exists;
		},
		// 아래는 Newjigu, HE에서만 사용됨
		checkShipmentCharge(apiCharge) {
			if (this.user.company_id == 'newjigu' || this.user.company_id == 'he') {
				if (apiCharge) {
					if (this.invoice.freight_charge != apiCharge) {
						if (this.invoice.freight_charge > 0) {
							if (confirm('Apply the API charge to the Invoice Freight Charge?')) {
								this.invoice.freight_charge = apiCharge;
								this.$alertify.alert('Alert', 'Freight Charge Changed. Please Save...');
							}
						} else {
							this.invoice.freight_charge = apiCharge;
							this.$alertify.alert('Alert', 'Freight Charge Changed. Please Save...');
						}
					}
				}
			}
			//this.closeModal();
		},
		gotoSO(invoice_no, window_name) {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice_no } });
			window.open(routeData.href, window_name);
		},
		openSO() {
			this.gotoSO(this.invoice.invoice_no, 'herp_so');
		},
		makeReturnSO() {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, all_return: true, org_invoice_no: this.invoice.invoice_no } });
			window.open(routeData.href, 'herp_so');
		},
		isChargeChanged() {
			// BP, HP가 아니면 그냥 false 리턴
			if (this.user.company_id != 'beautyplus' && this.user.company_id != 'hairplus') return false;

			if (
				this.invoice.freight_charge == this.stored_invoice.freight_charge &&
				this.invoice.fuel_charge == this.stored_invoice.fuel_charge &&
				this.invoice.insurance_charge == this.stored_invoice.insurance_charge &&
				this.invoice.shipping_charge_discount_amount == this.stored_invoice.shipping_charge_discount_amount
			)
				return false;
			return true;
		},
		sortName() {
			//console.log('sort Name');
			this.items = _.sortBy(this.items, 'name');
		},
		dblclickItem(item) {
			if (this.invoice.invoice_type != 'S') return;

			if (item.shipped_quantity_abs == item.quantity_abs) item.shipped_quantity_abs = 0;
			else item.shipped_quantity_abs = item.quantity_abs;
		},
		async viewHistoryItems(history) {
			const { data } = await apiSelectInvoiceHistoryItemList({
				invoice_history_no: history.invoice_history_no,
			});
			//console.log(data.invoice);

			this.popup_items = data.invoiceHistoryItemList;

			//console.log(history);
			//console.log(this.history_items);
			this.prevModalName = 'History';
			this.modalName = 'HistoryItems';
		},
		viewHistory() {
			this.modalName = 'History';
			this.showModal = true;

			//console.log(this.histories);
		},
		closeModalItems() {
			//this.modalName = 'History';
			this.modalName = this.prevModalName;
		},
		setDeliveryTypeName(code) {
			//console.log(code);
			if (code) this.invoice.delivery_type_name = code.name;
			else this.invoice.delivery_type_name = '';

			this.$forceUpdate();

			//this.selectUsers();
		},
		setShipChargeName(code) {
			//console.log(code);
			if (code) this.invoice.ship_charge_name = code.name;
			else this.invoice.ship_charge_name = '';
			//this.selectUsers();
		},
		setPaymentTermName(code) {
			//console.log(code);
			if (code) this.invoice.payment_term_name = code.name;
			else this.invoice.payment_term_name = '';
			//this.selectUsers();
		},
		calTotal() {
			var total_amount = 0;
			var total_quantity = 0;
			var total_shipped_amount = 0;
			var total_shipped_quantity = 0;

			var vm = this;
			this.items.forEach(function(item) {
				if (vm.invoice.invoice_type == 'R') {
					item.quantity = item.quantity_abs * -1;
					item.shipped_quantity = item.shipped_quantity_abs * -1;
				} else {
					item.quantity = item.quantity_abs;
					item.shipped_quantity = item.shipped_quantity_abs;
					item.scant_quantity = item.shipped_quantity > 0 ? item.quantity - item.shipped_quantity : item.quantity;
					//console.log(item.scant_quantity, vm.allSelected);
					if (item.scant_quantity > 0) {
						//} && vm.allSelected) {
						item.bo_quantity = item.scant_quantity;
						//console.log('strange', item.bo_quantity);
						item.selected = true;
					}
				}
				item.amount = item.quantity * item.unit_price;
				item.shipped_amount = item.shipped_quantity * item.unit_price;

				total_quantity += item.quantity;
				total_amount += item.amount;
				total_shipped_quantity += item.shipped_quantity;
				total_shipped_amount += item.shipped_amount;
			});

			this.invoice.total_quantity = total_quantity;
			this.invoice.total_amount = total_amount;
			this.invoice.total_shipped_quantity = total_shipped_quantity;
			this.invoice.total_shipped_amount = total_shipped_amount;

			if (
				(this.user.company_id == 'hairplus' || this.user.company_id == 'beautyplus') &&
				// (this.invoice.payment_term_code != this.invoice.payment_term_code_org || this.invoice.delivery_type_code != this.invoice.delivery_type_code_org || this.invoice.ship_charge_code != this.invoice.ship_charge_code_org)
				(this.invoice.payment_term_code != this.invoice.payment_term_code_org || this.invoice.ship_charge_code != this.invoice.ship_charge_code_org)
			) {
				// if (
				// 	(this.invoice.payment_term_code_org && this.invoice.payment_term_code != this.invoice.payment_term_code_org) ||
				// 	(this.invoice.delivery_type_code_org && this.invoice.delivery_type_code != this.invoice.delivery_type_code_org) ||
				// 	(this.invoice.ship_charge_code_org && this.invoice.ship_charge_code != this.invoice.ship_charge_code_org)
				// ) {
				this.setDefaultCharges();

				// if ((this.invoice.delivery_type_code_org && this.invoice.delivery_type_code != this.invoice.delivery_type_code_org) || (this.invoice.ship_charge_code_org && this.invoice.ship_charge_code != this.invoice.ship_charge_code_org))
				// 	alert('Check Delivery Type and Ship Charge');

				if (this.invoice.ship_charge_code_org && this.invoice.ship_charge_code != this.invoice.ship_charge_code_org) alert('Check Delivery Type and Ship Charge');

				this.invoice.payment_term_code_org = this.invoice.payment_term_code;
				//this.invoice.delivery_type_code_org = this.invoice.delivery_type_code;
				this.invoice.ship_charge_code_org = this.invoice.ship_charge_code;
			}

			//console.log('rate', this.invoice.shipping_charge_discount_rate);
			//this.invoice.fuel_charge = parseFloat((this.invoice.freight_charge * this.invoice.fuel_rate).toFixed(2));
			//this.invoice.fuel_charge = Math.round((this.invoice.freight_charge * this.invoice.fuel_rate + Number.EPSILON) * 100) / 100;

			//this.invoice.insurance_charge = parseFloat((this.invoice.total_shipped_amount * this.invoice.insurance_rate).toFixed(2));
			if (this.invoice.freight_charge > 0) {
				this.invoice.fuel_charge = Math.round((this.invoice.freight_charge * this.invoice.fuel_rate + Number.EPSILON) * 100) / 100;
				this.invoice.insurance_charge = Math.round((this.invoice.total_shipped_amount * this.invoice.insurance_rate + Number.EPSILON) * 100) / 100;
			} else {
				this.invoice.fuel_charge = 0;
				this.invoice.insurance_charge = 0;
			}
			//this.invoice.insurance_charge = Math.round((this.invoice.total_shipped_amount * this.invoice.insurance_rate + Number.EPSILON) * 100) / 100;

			this.invoice.shipping_charge = this.invoice.freight_charge + this.invoice.fuel_charge + this.invoice.insurance_charge;
			if (this.invoice.shipping_charge_discount_rate) {
				//this.invoice.shipping_charge_discount_amount = parseFloat((this.invoice.shipping_charge * this.invoice.shipping_charge_discount_rate).toFixed(2));
				this.invoice.shipping_charge_discount_amount = Math.round((this.invoice.shipping_charge * this.invoice.shipping_charge_discount_rate + Number.EPSILON) * 100) / 100;
			} else {
				this.invoice.shipping_charge_discount_amount = 0;
			}

			this.invoice.total_charge =
				this.invoice.shipping_charge -
				this.invoice.shipping_charge_discount_amount +
				this.invoice.cod_charge +
				this.invoice.handling_charge -
				this.invoice.special_discount +
				(this.invoice.invoice_type == 'S' ? this.invoice.bounce_fee : 0) +
				this.invoice.restock_fee +
				this.invoice.other_charge;
			//if (this.invoice.bounce_fee) this.invoice.total_charge += this.invoice.bounce_fee;
			//this.invoice.invoice_amount = this.invoice.total_charge + this.invoice.total_shipped_amount;
			if (this.invoice.international) {
				var adj_total = 0;
				//var vm = this;
				this.items.forEach(i => {
					adj_total += i.shipped_quantity * i.unit_price * vm.invoice.price_rate;
				});
				//this.invoice.invoice_amount = this.invoice.total_charge + Math.round((adj_total + Number.EPSILON) * 100) / 100;
				this.invoice.invoice_amount = Math.round((this.invoice.total_charge + Number.EPSILON) * 100) / 100 + Math.round((adj_total + Number.EPSILON) * 100) / 100;
			} else {
				//this.invoice.invoice_amount = this.invoice.total_charge + this.invoice.total_shipped_amount;
				this.invoice.invoice_amount = Math.round((this.invoice.total_charge + Number.EPSILON) * 100) / 100 + Math.round((this.invoice.total_shipped_amount + Number.EPSILON) * 100) / 100;
			}

			//console.log(this.invoice.total_charge, this.invoice.invoice_amount);

			//this.$forceUpdate();

			//this.invoice.insurance_charge = parseFloat((this.invoice.total_shipped_amount * this.invoice.insurance_rate).toFixed(2));
		},
		goTo(colType, index, diff) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'shipped_quantity') this.$refs.shipped_quantity[index].$el.select();
					else if (colType == 'bo_quantity') this.$refs.bo_quantity[index].$el.select();
					// else if (colType == 'quantity') this.$refs.quantity[index].$el.select();

					if (diff == 1 && this.$refs.shipped_quantity[index].$el.offsetParent.offsetTop + this.$refs.invoice_items.offsetTop + 1 * this.$refs.shipped_quantity[index].$el.offsetParent.scrollHeight > window.innerHeight) {
						window.scrollTo(window.scrollX, window.scrollY + this.$refs.shipped_quantity[index].$el.offsetParent.scrollHeight + 1);
					} else if (diff == -1 && this.$refs.shipped_quantity[index].$el.offsetParent.offsetTop + this.$refs.invoice_items.offsetTop - 1 * this.$refs.shipped_quantity[index].$el.offsetParent.scrollHeight < window.scrollY) {
						window.scrollTo(window.scrollX, this.$refs.shipped_quantity[index].$el.offsetParent.offsetTop + this.$refs.invoice_items.offsetTop - this.$refs.shipped_quantity[index].$el.offsetParent.scrollHeight - 20);
					}
				}
			});
		},
		pickUser() {
			this.modalName = 'UserSelect';
			this.showModal = true;
		},
		async setUsers(selectedUserIds) {
			if (selectedUserIds.length != 1) {
				this.$toast.error('Invalid User');
			} else {
				this.invoice.packed_user = selectedUserIds[0];
				alert("Please Save this Invoice to apply 'Boxed By' User");
			}
		},
		shipment() {
			if (this.invoice.box_count > 0) {
				if (this.invoice.temp_flag) this.modalName = 'ShipmentTemp';
				else this.modalName = 'Shipment';
				this.showModal = true;

				//this.invoice.check_shipment_email = true;
			} else {
				this.$toast.error('No Box');
			}
		},
		async updateInvoiceVoid(status_code) {
			// if (status_code == 'VI' && this.invoice.invoice_amount != this.invoice.balance) {
			// 	this.$toast.error('This invoice was paid. Make the payment reversed first.');
			// 	return;
			// }

			this.invoice.status_code = status_code;
			const { data } = await apiUpdateInvoiceVoid(this.invoice);

			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
				if (status_code == 'VI') this.invoice.status_code = 'I';
				else if (status_code == 'I') this.invoice.status_code = 'VI';
			}
		},
		selectItem(item) {
			if (this.user.company_id == 'newjigu') {
				let routeData = this.$router.resolve({ name: 'itemInquiry', query: { backUri: this.uri, partner_code: this.invoice.ship_to_code, class_code: item.class_code } });
				window.open(routeData.href, 'herp_item_inquiry');
			} else {
				let routeData = this.$router.resolve({ name: 'itemMaster', query: { backUri: this.$route.fullPath, keyword: item.item_id } });
				window.open(routeData.href, 'herp_item');
			}
		},
		selectColor(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		onTotalWeightInput() {
			// #3140 실제 DOM 입력(타이핑 · 붙여넣기 · 잘라내기 · 드래그)에서만 발생한다.
			// currency-input 의 프로그램적 재포맷은 native input 을 발생시키지 않으므로 여기 걸리지 않는다.
			if (this.totalWeightReadonly) return;
			this.total_weight_touched = true;
		},
		onTotalWeightChange() {
			// 수동 입력이 허용된 화면(jc · 수정권한 · Sales Invoice)이 아니면 수동값을 절대 만들지 않는다.
			if (this.totalWeightReadonly) return;
			// 사용자가 실제로 값을 고친 경우에만 수동값으로 인정한다. (프로그램적 재포맷/대입으로 인한 change 는 무시)
			if (!this.total_weight_touched) return;
			this.total_weight_touched = false;
			// 양의 정수만 수동값으로 인정한다. 0 · 빈값 · 음수는 수동값 해제(자동계산 복귀).
			const v = Math.floor(Number(this.invoice.total_weight));
			if (!v || isNaN(v) || v <= 0) {
				this.useAutoTotalWeight();
				return;
			}
			this.invoice.manual_total_weight = v;
			this.invoice.total_weight = v;
			// 서버는 이 플래그가 있을 때만 manual_total_weight 를 UPDATE 한다 (구버전 클라이언트가 값을 지우지 못하게)
			this.$set(this.invoice, 'manual_total_weight_changed', true);
		},
		useAutoTotalWeight() {
			// 수동값 해제 → 서버가 내려준 자동계산값(박스 합계)으로 되돌린다.
			// 아래 대입이 유발하는 프로그램적 change 가 stale 플래그를 소비하지 못하도록 먼저 내린다.
			this.total_weight_touched = false;
			this.invoice.manual_total_weight = null;
			this.invoice.total_weight = this.invoice.calculated_total_weight;
			this.$set(this.invoice, 'manual_total_weight_changed', true);
			this.$nextTick(() => {
				this.total_weight_touched = false;
			});
		},
		reboxing() {
			// console.log(this.invoice);
			// if (this.invoice.status_code != 'VI') {
			// 	this.$alertify.alert('Alert', 'Only voided invoice can be re-boxed.');
			// 	return;
			// }
			this.$router.push({ name: 'boxing', query: { backUri: this.$route.fullPath, so_dn: this.invoice.so_dn } });
		},
		async setInvoiceFromList(invoice) {
			const { data } = await apiSelectInvoice({
				invoice_no: invoice.invoice_no,
				include_box: true,
			});
			this.setInvoice(data.invoice);
		},

		async setBoxinformation(invoice) {
			const { data } = await apiSelectBoxInformation({
				invoice_no: invoice.invoice_no,
			});
			this.boxes = data.boxList;
			//console.log(this.boxes);

			if (this.boxes.length > 0 && this.boxes.filter(b => !(b.weight > 0)).length > 0) {
				this.$alertify.alert('Alert', 'Exists box(es) with no weight');
			}
		},
		async setInvoice(invoice) {
			if (invoice.invoice_dn) {
				this.$toast.error('Invoice already exists.');
				//this.search();
				return;
			}

			this.invoice = invoice;

			await this.setBoxinformation(invoice);

			//console.log(today().substring(3, 5));
			if (this.user.company_id == 'beautyplus' && this.invoice.so_date.substring(0, 2) != today().substring(0, 2) && today().substring(3, 5) == '01') {
				//console.log(this.invoice.so_date.substring(6), this.invoice.so_date.substring(0, 2));
				var d = new Date(this.invoice.so_date.substring(6), this.invoice.so_date.substring(0, 2), 0);
				//console.log(d);
				//console.log(toText(d, '-'));
				this.invoice.invoice_date = toText(d, '-');
			} else {
				//console.log(this.invoice.so_date.substring(0, 2));
				this.invoice.invoice_date = today();
			}
			//console.log(this.invoice.shipping_charge_discount_rate);
			//console.log(this.invoice);

			var process_bounce_fee = true;

			// #3151 arkin: bounce fee를 다음 invoice에 자동 합산하지 않음 (합산하면 원본 BC invoice가 offset 삭제되어 AR에서 사라짐)
			if (this.user.company_id == 'arkin') {
				process_bounce_fee = false;
			} else if (this.invoice.old_bounce_fee_sum > 0) {
				if (this.user.company_id == 'newjigu') {
					if (!confirm('Bounce fee : ' + this.invoice.old_bounce_fee_sum + ' exists. Apply bounce fee?')) {
						process_bounce_fee = false;
					}
				}
			}

			if (process_bounce_fee) {
				this.invoice.bounce_fee = this.invoice.old_bounce_fee_sum;
			} else {
				this.invoice.bounce_fee = null;
				this.invoice.old_bounce_invoice_nos = null;
			}

			const { data } = await apiSelectInvoiceItemList({
				invoice_no: this.invoice.invoice_no,
				bill_to_code: this.invoice.bill_to_code,
				include_partner: true,
				include_history: true,
			});

			this.items = data.invoiceItemList;
			this.items.forEach(i => {
				//i.org_shipped_quantity_abs = i.shipped_quantity_abs;
				if (i.shipped_quantity_abs > i.quantity_abs) i.max_quantity = i.shipped_quantity_abs;
				else i.max_quantity = i.quantity_abs;

				//console.log(i.max_quantity);
			});
			this.partner = data.partner;
			this.bill_partner = data.bill_partner;
			this.histories = data.invoiceHistoryList;
			//console.log(this.histories);

			this.cod_free = false;
			this.handling_charge_free = false;

			this.setDefaultCharges();

			if (this.invoice.has_valid_additional_so) {
				this.$toast.error('Valid additional sales order exists.');
			}

			if (this.invoice.main_invoice_no) {
				this.$toast.error('Additional sales order');
			}

			if (this.mode == 'add' && (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus')) {
				await this.loadShipInfo();
			}

			this.loadPreviouseInvoices(this.invoice.ship_to_code, 1);

			//this.search();
		},
		async loadShipInfo() {
			const { data } = await apiSelectDeliveryTypeChangeHistory({ invoice_no: this.invoice.invoice_no });

			var changes = data.deliveryChangeHistory;
			//console.log(changes);
			if (changes.length > 1 && changes[1].toUpperCase().includes('UPS') && (changes[0].toUpperCase().includes('DELIVERY') || changes[0].toUpperCase().includes('PICKUP'))) {
				this.$alertify.alert('Alert', 'Delivery type has been changed. Please notify warehouse people about this.');
			}
		},
		setDefaultCharges() {
			//var p = data.partner;
			//console.log(this.bill_partner);

			if (this.invoice.invoice_type == 'S') {
				if (this.bill_partner.cod_free_yn != 'Y' && this.invoice.payment_term_name && this.invoice.payment_term_name.toUpperCase().indexOf('COD') >= 0) this.invoice.cod_charge = this.profile.default_cod_charge;

				if (this.invoice.ship_charge_code == 'UF' || this.invoice.ship_charge_code == 'FF') this.invoice.handling_charge = this.profile.default_handling_charge;
				else this.invoice.handling_charge = 0;

				var dtn = this.invoice.delivery_type_name;
				if (dtn) dtn = dtn.toUpperCase();

				//if (!dtn || dtn.startsWith('DELIVERY') || dtn.startsWith('PICKUP') || dtn.startsWith('TRUCKING') || this.invoice.ship_to_country != 'US') {
				//if (!dtn || dtn.startsWith('DELIVERY') || dtn.startsWith('PICKUP') || (dtn.startsWith('TRUCKING') && this.invoice.ship_to_country != 'US') || this.invoice.ship_to_country != 'US') {
				//

				var shipping_free = false;

				if (!dtn || dtn.startsWith('DELIVERY') || dtn.startsWith('PICKUP')) {
					shipping_free = true;
				} else {
					if (this.user.company_id == 'hairplus' || this.user.company_id == 'beautyplus') {
						if (dtn.startsWith('TRUCKING') && this.invoice.ship_to_country != 'US') shipping_free = true;
					} else {
						if (dtn.startsWith('TRUCKING') || this.invoice.ship_to_country != 'US') shipping_free = true;
					}
				}

				if (shipping_free) {
					this.invoice.freight_charge = 0;
					this.invoice.fuel_rate = 0;
					this.invoice.insurance_rate = 0;
				} else {
					this.invoice.freight_charge = this.invoice.box_freight_charge_sum;
					this.invoice.fuel_rate = this.profile.fuel_rate;
					this.invoice.insurance_rate = this.profile.insurance_rate;
				}

				if (this.user.company_id == 'hairplus' || this.user.company_id == 'beautyplus') {
					if (this.invoice.ship_charge_code == 'UF' || this.invoice.ship_charge_code == 'FF' || this.invoice.ship_charge_code == 'TU') this.shipping_charge_discount_rate_percent = 100.0;
					else if (this.invoice.ship_charge_code == 'U3') this.shipping_charge_discount_rate_percent = 75.0;
					else if (this.invoice.ship_charge_code == 'UQ') this.shipping_charge_discount_rate_percent = 66.67;
					else if (this.invoice.ship_charge_code == 'UH' || this.invoice.ship_charge_code == 'FH' || this.invoice.ship_charge_code == 'TH') this.shipping_charge_discount_rate_percent = 50.0;
					else if (this.invoice.ship_charge_code == 'UT') this.shipping_charge_discount_rate_percent = 33.33;
					else if (this.invoice.ship_charge_code == 'U1') this.shipping_charge_discount_rate_percent = 25.0;
					else this.shipping_charge_discount_rate_percent = 0;
				} else if (this.user.company_id == 'newjigu') {
					if (this.invoice.ship_charge_code == 'UF' || this.invoice.ship_charge_code == 'FF' || this.invoice.ship_charge_code == 'TF') this.shipping_charge_discount_rate_percent = 100.0;
					else if (this.invoice.ship_charge_code == 'U3' || this.invoice.ship_charge_code == 'F3') this.shipping_charge_discount_rate_percent = 75.0;
					else if (this.invoice.ship_charge_code == 'U2' || this.invoice.ship_charge_code == 'F2') this.shipping_charge_discount_rate_percent = 66.67;
					else if (this.invoice.ship_charge_code == 'UH' || this.invoice.ship_charge_code == 'FH' || this.invoice.ship_charge_code == 'TH') this.shipping_charge_discount_rate_percent = 50.0;
					else if (this.invoice.ship_charge_code == 'UT' || this.invoice.ship_charge_code == 'FT') this.shipping_charge_discount_rate_percent = 33.33;
					else if (this.invoice.ship_charge_code == 'U1' || this.invoice.ship_charge_code == 'F1') this.shipping_charge_discount_rate_percent = 25.0;
					else this.shipping_charge_discount_rate_percent = 0;
				}
			}

			//console.log(this.partner);
			if (this.bill_partner.cod_free_yn == 'Y') this.cod_free = true;
			if (this.bill_partner.handling_charge_free_yn == 'Y') this.handling_charge_free = true;

			//console.log(this.handling_charge_free);

			if (this.cod_free || ((this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') && (!dtn || dtn.startsWith('DELIVERY') || dtn.startsWith('PICKUP') || dtn.startsWith('TRUCKING')))) this.invoice.cod_charge = 0;

			if (this.handling_charge_free || !dtn || dtn.startsWith('DELIVERY') || dtn.startsWith('PICKUP') || dtn.startsWith('TRUCKING')) this.invoice.handling_charge = 0;

			//this.$forceUpdate();
		},
		async search() {
			if (!this.invoice.so_dn) {
				this.$toast.error('Empty So No.');
				return;
			}
			//console.log('Searching SO:', this.sono);
			const { data } = await apiSelectInvoice({
				//invoice_no: this.invoice.invoice_no,
				so_dn: this.invoice.so_dn,
				include_box: true,
			});

			if (data.invoice) this.setInvoice(data.invoice);
			else this.$toast.error('Not found');
		},
		selectAll() {
			if (this.allSelected) {
				this.items.forEach(item => {
					item.shipped_quantity_abs = item.quantity_abs;
				});
			} else {
				this.items.forEach(item => {
					item.shipped_quantity_abs = 0;
				});
			}
		},
		checkBackOrder(item) {
			if (item.selected) item.bo_quantity = item.scant_quantity;
			else item.bo_quantity = null;
		},
		checkValidity() {
			if (!this.invoice.invoice_no) {
				this.$toast.error('Invalid Invoice');
				return false;
			}

			if (!this.invoice.invoice_date) {
				this.$toast.error('Empty Invoice Date');
				return false;
			}

			if (this.invoice.shipment_info_exists && this.invoice.cod_amount > 0 && this.invoice.cod_amount != this.invoice.invoice_amount) {
				if (this.user.company_id == 'hairplus') {
					this.$toast.warning('Shipment with COD label exists and invoice amount and COD amount is different. Please check after saving.', { duration: 10000, pauseOnHover: false });
				} else {
					this.$toast.error('Shipment with COD label exists and invoice amount and COD amount is different. Void the label to modify the invoice amount.', { duration: 10000, pauseOnHover: false });
					return false;
				}
			}

			return true;
		},
		selectPrevSO(invoice) {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			window.open(routeData.href, 'herp_so_detail');
		},
		gotoInvoice(invoice_no) {
			console.log(invoice_no);
			// let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice_no } });
			// window.open(routeData.href, 'herp_invoice_detail');
		},
		selectPrevInvoice(invoice) {
			// if (invoice.invoice_type == 'R') {
			// 	this.$toast.warning('Return SO will be developed later.');
			// 	return;
			// }
			//console.log(invoice);

			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			//this.gotoInvoice(invoice.invoice_no);
			this.mode = 'detail';
			this.$store.commit('setSubTitle', 'Invoice -> Detail');
			this.invoice.invoice_no = invoice.invoice_no;
			this.selectInvoice();
		},
		async loadPreviouseInvoices(partner_code, pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('Loading Previous invoices of ', partner_code);
			const { data } = await apiSelectInvoiceList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				ship_to_code: partner_code,
				post_check_status: true,

				status_code: 'I',

				sort_key: 'so_date',
				sort_direction: 'DESC',
			});

			this.prevInvoices = data.invoiceList;
			this.prevInvoicesCount = data.invoicesSum.list_count;
			this.prevInvoicesBalanceSum = data.invoicesSum.balance_sum;
			this.postChecks = data.postCheckList;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.prevInvoicesCount);
		},
		async selectInvoice() {
			const { data } = await apiSelectInvoice({
				invoice_no: this.invoice.invoice_no,
				include_partner: true,
				include_history: true,
				include_box: true,
				//include_shipment: true,
			});
			//console.log(data.invoice);
			//console.log(this.profile);
			this.stored_invoice = _.cloneDeep(data.invoice);

			this.invoice = data.invoice;
			// #3140 프로그램적 대입이므로 사용자 편집 플래그를 반드시 내린다
			this.total_weight_touched = false;
			this.items = data.invoiceItemList;
			//console.log(this.items);
			this.items.forEach(i => {
				if (i.shipped_quantity_abs > i.quantity_abs) i.max_quantity = i.shipped_quantity_abs;
				else i.max_quantity = i.quantity_abs;
			});
			this.partner = data.partner;
			this.bill_partner = data.bill_partner;
			//console.log(this.bill_partner);
			this.histories = data.invoiceHistoryList;
			//console.log(this.histories);

			// this.shipment = data.shipment;
			//console.log(this.partner);
			//console.log(this.invoice);

			this.cod_free = false;
			this.handling_charge_free = false;

			this.invoice.payment_term_code_org = this.invoice.payment_term_code;
			this.invoice.delivery_type_code_org = this.invoice.delivery_type_code;
			this.invoice.ship_charge_code_org = this.invoice.ship_charge_code;

			if (this.invoice.invoice_type == 'S') {
				// if (!this.invoice.fuel_rate) this.invoice.fuel_rate = this.profile.fuel_rate;
				// if (!this.invoice.fuel_charge) this.invoice.fuel_charge = this.invoice.freight_charge * this.invoice.fuel_rate;
				// if (!this.invoice.insurance_rate) this.invoice.insurance_rate = this.profile.insurance_rate;
				// if (!this.invoice.insurance_charge) this.invoice.insurance_charge = this.invoice.total_shipped_amount * this.invoice.insurance_rate;
				if (this.bill_partner.cod_free_yn == 'Y') this.cod_free = true;
				if (this.bill_partner.handling_charge_free_yn == 'Y') this.handling_charge_free = true;
			}

			this.stored_invoice_amount = this.invoice.invoice_amount;
			//this.save_complete = false;
			//console.log(this.stored_invoice);
		},
		async save(stay) {
			if (this.checkValidity()) {
				// if (this.mode == 'detail') {
				// 	var update_reason = prompt('Input update remark', '');
				// 	if (update_reason) console.log(update_reason, stay);
				// }
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		updateRemark() {
			this.modalName = 'Update';
			this.showModal = true;
		},
		updateRemarkConfirm(update_remark) {
			this.submit(this.temp_stay, update_remark);
		},
		async submit(stay, update_remark, from_shipment_popup) {
			this.calTotal();

			this.invoice.update_remark = null;
			if (this.mode == 'add') {
				this.invoice.status_code = 'I';
				this.invoice.status_changed_yn = 'Y';
			} else {
				// this.invoice.update_remark = prompt('Input update remark', '');
				// if (!this.invoice.update_remark) {
				// 	this.$toast.error('Save canceled.');
				// 	return;
				// }
				if (update_remark) {
					this.invoice.update_remark = update_remark;
				} else {
					this.temp_stay = stay;
					this.updateRemark();
					return;
				}
			}
			this.invoice.items = this.items;
			const { data } = await apiSubmitInvoiceAfterBoxing(this.invoice, this.mode);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.stored_invoice_amount = this.invoice.invoice_amount;

				if (this.mode == 'detail') {
					if (from_shipment_popup) {
						this.$refs.shipmentPopup.reload();
					} else {
						this.$alertify.alert('Alert', 'Check the previous invoice issued and bring that back');
					}
				} else if (this.mode == 'add') {
					if (this.user.company_id == 'beautyplus' && !(this.invoice.invoice_amount > 300)) {
						if (!this.invoice.delivery_type_name.toUpperCase().startsWith('DELIVERY') && !this.invoice.delivery_type_name.toUpperCase().startsWith('PICKUP')) this.$alertify.alert('Alert', 'Please be aware. This order is not over $300.');
					} else if (this.user.company_id == 'hairplus' && !(this.invoice.invoice_amount > 500)) {
						this.$alertify.alert('Alert', 'Please be aware. This order is not over $500.');
					}

					if (this.user.company_id == 'beautyplus' && this.fedexAccountChanged) {
						this.$alertify.alert('Alert', 'Customer account NO changed. Please print the label in the Shipment section for the reference in WH.');
					}
				}

				if (!stay) {
					this.save_complete = true;
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.invoice.invoice_dn = data.invoice_dn;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Invoice -> Detail');

						//await this.selectInvoice();
					}

					await this.selectInvoice();

					//this.invoice.payment_term_code_org = this.invoice.payment_term_code;
					//this.invoice.delivery_type_code_org = this.invoice.delivery_type_code;
					//this.invoice.ship_charge_code_org = this.invoice.ship_charge_code;
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async getSalesmanList() {
			const { data } = await apiSelectUserList({
				active_yn: 'Y',
				user_type: 'salesman',
				sort_key: 'user_name',
			});

			this.salesmans = data.userList;
		},
		async index() {
			const { data } = await apiSoIndex();

			this.paymentTerms = data.paymentTermList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.deliveryTypes = data.deliveryTypeList;
			this.remarks = data.remarkList;
			this.specialSales = data.specialSaleList;

			await this.getSalesmanList();
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			if (this.mode == 'detail') {
				await this.selectInvoice();
				await this.loadPreviouseInvoices(this.invoice.ship_to_code, 1);
				inputSelectOnClick();
				this.load_complete = true;
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			} else if (this.mode == 'add' && this.$route.query.invoice_no) {
				this.load_complete = true;
				const { data } = await apiSelectInvoice({
					invoice_no: this.$route.query.invoice_no,
					include_box: true,
				});
				this.setInvoice(data.invoice);
			} else {
				this.load_complete = true;
			}

			this.invoice.check_shipment_email = false;

			//console.log(this.invoice);

			//console.log(this.shipToAddressString());

			//console.log(this.profile);
		},
		async updateInvoicePrint(data) {
			if (!data || !data.invoice) return;

			//if (!data.invoice.invoice_print_user) {
			this.$nextTick(async () => {
				if (this.$store.getters.getShowModal) {
					let { status } = await apiUpdateInvoicePrint(this.invoice.invoice_no);
					if (status !== 200) this.$toast.error('Failed');
				}
			});
			//}
		},
		async processInvoicePrint(data, openMailModal) {
			let file = 'invoice';
			if (this.invoice.international) file = 'international_invoice';
			if (this.invoice.invoice_type === 'R') file = 'ReturnList';

			let toList = [];
			if (this.bill_partner.email) toList.push(this.bill_partner.email);
			let reportTemplate;
			let file_name = this.invoice.bill_to_code + '(' + this.invoice.invoice_dn + ')';
			if (this.user.company_id == 'newjigu') file_name = 'Harlem 125 - ' + this.invoice.invoice_dn;

			if (file === 'international_invoice') {
				reportTemplate = await apiGetReportTemplate(file, companyMrtUrl(file));
			} else {
				if (this.invoice.invoice_type == 'S' && this.profile.use_temp_flag == 'Y' && this.invoice.temp_flag) file = file + '_temp_flag'; //임시

				reportTemplate = await apiGetBase64ReportTemplate(file, companyMrtUrl(file));
			}

			const report = new Report(reportTemplate, data, file_name, PrintType.Normal, false, openMailModal, toList);
			this.$store.commit('setReport', report);

			await this.updateInvoicePrint(data);
		},
		async print() {
			if (this.invoice.status_code == 'VI') {
				alert('Void invoice. Revive first');
				return;
			}

			if (this.invoice.invoice_amount.toFixed(2) != this.stored_invoice_amount.toFixed(2)) {
				alert('Amount changed. Save first');
				return;
			}

			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);

			let msg = '';
			if (this.user.company_id === 'hairplus') {
				if (data && data.invoice && data.invoice.showCredit && Array.isArray(data.invoice.otherInvoiceList)) {
					if (data.invoice.otherInvoiceList.reduce((prev, curr) => prev + curr.balance, 0) !== 0) {
						msg += 'Credits exist. Credits will be applied for the invoice.';
					}
				}
			}
			if (data.invoice.invoice_print_user) {
				if (msg) {
					msg = '1. ' + msg + '<br />2. ';
				}

				msg += 'An original Invoice was already printed. Would you want to reprint it?';
			}

			if (msg) {
				this.$alertify.confirm(msg, async () => this.processInvoicePrint(data, false));
			} else {
				this.processInvoicePrint(data, false);
			}
		},

		async printProfoma() {
			// newjigu이고, 'I'가 아닌 경우만
			if (!this.user || this.user.company_id != 'newjigu' || this.invoice.status_code != 'W') return;

			const total_item_amount = this.items.reduce((prev, curr) => prev + curr.real_c_price * curr.shipped_quantity, 0);
			const proforma_inv = _.cloneDeep(this.invoice);
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			const print_inv = data.invoice;

			proforma_inv.total_item_amount = total_item_amount;
			proforma_inv.total_item_discount = proforma_inv.total_shipped_amount - total_item_amount;
			proforma_inv.invoice_items = this.items;
			proforma_inv.aging = print_inv.aging;
			proforma_inv.bill_partner = print_inv.bill_partner;
			proforma_inv.ship_partner = print_inv.ship_partner;
			proforma_inv.company = print_inv.company;
			proforma_inv.shipment = print_inv.shipment;

			const reportTemplate = await apiGetReportTemplate('ProformaBeforeInvoice', companyMrtUrl('ProformaBeforeInvoice'));
			const report = new Report(reportTemplate, { invoice: proforma_inv }, 'ProformaBeforeInvoice');
			this.$store.commit('setReport', report);
		},

		async mail() {
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			this.processInvoicePrint(data, true);
		},
		async excelExportForItems() {
			const { data } = await apiInvoicePrintData(this.invoice.invoice_no);
			const invoice = data.invoice || {};
			const invoice_items = Array.isArray(data.invoice.invoice_items) ? data.invoice.invoice_items : [];
			const export_data = invoice_items.map(ii => ({
				display_invoice_date: `${toText(toDate(invoice.invoice_date), '/')} (${getDayOfWeek(toDate(invoice.invoice_date))})`,
				invoice_dn: invoice.invoice_dn,
				bill_to_code: invoice.bill_to_code,
				customer_po_no: invoice.customer_po_no,
				ship_to_code: invoice.ship_to_code,
				barcode: ii.barcode,
				item_code: ii.item_code,
				name: ii.name,
				color_code: ii.color_code,
				shipped_quantity: ii.shipped_quantity,
				unit_price: ii.unit_price,
				shipped_amount: ii.shipped_amount,
			}));

			const headers = [
				{ key: 'display_invoice_date', name: 'Invoice Date', width: 20, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice No.', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Bill to Code', width: 15, dataType: defaultDataType.string },
				{ key: 'customer_po_no', name: 'Cust. PO No.', width: 20, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship to Code', width: 15, dataType: defaultDataType.string },
				{ key: 'barcode', name: 'Barcode', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Description', width: 50, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'shipped_quantity', name: 'Ship QTY', width: 15, dataType: defaultDataType.currency },
				{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'shipped_amount', name: 'Total Price', width: 15, dataType: defaultDataType.number },
			];

			if (this.user.company_id == 'beautyplus') headers.splice(5, 0, { key: 'item_code', name: 'Item Code', width: 20, dataType: defaultDataType.string });

			exportDataExcel(export_data, headers, 'invoice_items');
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_invoice_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Invoice -> Add');
			this.invoice.invoice_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Invoice -> Detail');
			this.invoice.invoice_no = this.$route.query.invoice_no;

			if (!this.invoice.invoice_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		if (this.user.company_id == 'newjigu') this.initialFromDaysAgo = 180;

		this.profile = this.$session.get('profile');
		this.init();
		//console.log(this.backUri);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		//window.addEventListener('beforeunload', this.beforeWindowUnload);
		inputSelectOnClick();
		$(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });
	},
	// beforeDestroy() {
	// 	window.removeEventListener('beforeunload', this.beforeWindowUnload);
	// },
	// beforeWindowUnload(e) {
	// 	console.log(this.invoice.check_shipment_email && this.bill_partner.email);
	// 	if (this.invoice.check_shipment_email && this.bill_partner.email) {
	// 		if (confirm('Shall I email the customer with the shipping information?')) {
	// 			this.mail();
	// 			return;
	// 		}
	// 	}
	// 	e.preventDefault();
	// 	e.returnValue = '';
	// },
};
</script>

<style></style>
